import React from "react";
import styles from "./UserInfoStyle.style";
import {Panel, PanelHeader, PanelHeaderBack, ScreenSpinner} from "@vkontakte/vkui";
import {panels} from "../../variables";
import { setPreviousPanel } from "../../redux/actions/panelsActions";
import {connect} from "react-redux";
import UserInfoList from "./UserInfoList/UserInfoList";

const UserInfoPanel = ({ error, goBack, showLoader}) => {

    return (
        <Panel id={panels.userInfo}>
            <PanelHeader
                left={<PanelHeaderBack onClick={() => goBack()}/>}>
                <span style={styles.blue}>ГОС</span><span style={styles.red}>УСЛУГИ</span>
            </PanelHeader>
            {
                showLoader
                    ? <ScreenSpinner/>
                    : <>
                        {
                            error
                                ? "err"
                                : <UserInfoList/>
                        }
                    </>
            }
        </Panel>
    )
}

const mapStateToProps = (state) => {
    return {
        error: state.userInfo.error,
        showLoader: state.loader.showUserInfoLoader
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        goBack: () => dispatch(setPreviousPanel()),
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(UserInfoPanel);
